/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, { useState } from "react";
import useCarHighlightLocation from "../../../hooks/use-car-highlight-location";
import styles from "./styles.css";
import PropTypes from "prop-types";
import MapPin from "./images/map-pin.svg";
import InterStateCarModal from "../inter-state-car-modal/component";
import { getStateCode } from "../../../utils/helpers/checkout-util";
import rightArrow from "./images/right-arrow.svg";
import { useHistory } from "react-router";
import { LOGIN_SOURCE, LEAD_APPOINTMENT_STATUS } from "../../../constants/app-constants";
import getCarInfo from "../../../utils/helpers/get-car-info";
import { getDealerPage } from "../../../utils/helpers/get-dealer-route";
import DealerLocationModal from "../../shared/dealer-location-modal/component";
import HubLocationModal from "../hub-loaction-modal";

const CarLocationDetails = ({
    content,
    userGeoData,
    phoneNumberVerified,
    openLoginPopupConnect,
    setOnLoginSuccessCallback,
    createClassifiedLeadConnect,
    cmsConfig,
    setShowHubLocationModalConnect,
    showHubLocationModal,
    leadAppointment,
    dealerInfo,
    handleShowLoggedInDealerRedirect,
    isLoggedIn
}) => {
    const {
        cityCode = "",
        stateCode,
        distance,
        dealerCode,
        fullLocationLabel
    } = content || {};
    const history = useHistory();
    const {isInternalListing, isDealerListing}  = getCarInfo(content) || {};
    const [openInterstateModal, setOpenInterstateModal] = useState(false);
    const [dealerLocationModal, setShowDealerLocationModal] = useState(false);
    const { currentCarCityInfo = {} } = useCarHighlightLocation(cityCode);
    const cityHub = currentCarCityInfo || {};
    const {state: { isoCode: stateIsoCode } = {} } = userGeoData || {};
    const hubCityName = `${cityHub?.cityName}` || "";
    const currentStateCode = getStateCode({stateCode});
    const dealerInfoObject = dealerInfo?.[dealerCode] || {};
    const isInterstateLocation = (stateIsoCode !== currentStateCode);
    if (!cityHub?.cityName) {
        return null;
    }

    const onCardClick = () => {
        if (isInternalListing) {
            if (isInterstateLocation) {
                setOpenInterstateModal(true);
                return;
            }
            if (isInternalListing && isLoggedIn && !isInterstateLocation && cityHub?.address) {
                return;
            }
            setShowHubLocationModalConnect(true);
            return;
        } else {
            setShowDealerLocationModal(true);
            return;
        }
    };

    const onLoginClick = () => {
        const dealerName = dealerInfo?.[dealerCode]?.name || "";
        const dealerPage = getDealerPage(dealerName, dealerCode);
        if (phoneNumberVerified && leadAppointment?.status === LEAD_APPOINTMENT_STATUS.CONFIRM) {
            history.push(dealerPage);
        } else if (phoneNumberVerified && leadAppointment?.status !== LEAD_APPOINTMENT_STATUS.CONFIRM) {
            createClassifiedLeadConnect();
            handleShowLoggedInDealerRedirect(dealerPage);
        } else {
            setOnLoginSuccessCallback(() => {
                history.push(dealerPage);
            });
            openLoginPopupConnect({
                additionalInfo: { loginSource: LOGIN_SOURCE.CLASSISFIEDS, source: "Location", appointmentId: content?.appointmentId}
            });
        }
    };

    const getCityName = () => {
        // if (isInternalListing) {
        //     return suburbCity ? `Cars24, ${suburbCity}` : `Cars24 hub`;
        // }
        // return suburbCity ? suburbCity : dealerInfoObject.displayName;
        return fullLocationLabel;
    };

    return (
        <React.Fragment>

            <div onClick={onCardClick} className="media" styleName={"styles.locationCard"}>
                <img src={MapPin} />
                <div className="media-body">
                    <p styleName={"styles.locationHeading"}>{getCityName()}</p>
                    { isInternalListing && !isInterstateLocation ? <p styleName={"styles.intraStateText"}>{dealerInfoObject?.displayName}</p> : null}
                    {((isDealerListing || (!isInterstateLocation && !isLoggedIn))) ? <p styleName={"styles.locationText"}>View location<img src={rightArrow} /></p> : null}
                    {(isInternalListing && isLoggedIn && !isInterstateLocation && cityHub?.address) ? <p styleName={"styles.address"}>{cityHub?.address}</p> : null}
                    {isInternalListing && isInterstateLocation ? <p styleName={"styles.interstateWrap"}>This car’s in a different state, get it delivered to you easily with our Interstate delivery</p> : null}
                    {isInternalListing && isInterstateLocation ? <p styleName={"styles.locationText"}>Learn more about Interstate delivery<img src={rightArrow} /></p> : null}
                </div>
            </div>
            <InterStateCarModal
                isOpen={openInterstateModal}
                handleModalClose={() => setOpenInterstateModal(false)}
                stateData={{ cityName: hubCityName, stateIsoCode }}
                cmsConfig={cmsConfig}
            />
            {showHubLocationModal && <HubLocationModal onClose={() => setShowHubLocationModalConnect(false)} />}

            {
                dealerLocationModal && <DealerLocationModal
                    isOpen={dealerLocationModal}
                    handleClose={() => setShowDealerLocationModal(false)}
                    onLoginClick={onLoginClick}
                    isLoggedIn={isLoggedIn}
                    distance={distance}
                    dealerInfo={dealerInfoObject}
                    cmsConfig={cmsConfig}
                    leadAppointment={leadAppointment}
                />
            }
        </React.Fragment>
    );
};

CarLocationDetails.propTypes = {
    content: PropTypes.object,
    userGeoData: PropTypes.object,
    metaContent: PropTypes.object,
    phoneNumberVerified: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    openLoginPopupConnect: PropTypes.func,
    setOnLoginSuccessCallback: PropTypes.func,
    createClassifiedLeadConnect: PropTypes.func,
    cmsConfig: PropTypes.object,
    setShowHubLocationModalConnect: PropTypes.func,
    showHubLocationModal: PropTypes.bool,
    leadAppointment: PropTypes.object,
    dealerInfo: PropTypes.object,
    handleShowLoggedInDealerRedirect: PropTypes.func
};

export default CarLocationDetails;
